enum UserRoleEnum {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export default UserRoleEnum;
